// import React from 'react';
import TaskPanel from '../components/tasks/TasksPanel.tsx';
import { Container } from 'react-bootstrap';

const Tasks = () => {
  return (
    <Container className="mt-4">
      <h2>Maßnahmen</h2>
      <TaskPanel law_part_id={0} />
    </Container>
  );
};

export default Tasks;
